export default "__VITE_ASSET__fb045025__"